<!-- 出库审核 -->
<template>
  <article class="operate_from">
    <p class="tips-title" v-if="queryForm.action === 'approve'">审核通过</p>
    <p class="tips-title tips-finish" v-if="queryForm.action === 'approve'">确认二手车出库</p>
    <p class="tips-title tips-reject" v-else>驳回</p>
    <group>
      <x-textarea
        v-model.trim="queryForm.note"
        :max="255"
        :show-counter="true"
        :height="150"
        placeholder="请输入备注内容">
      </x-textarea>
    </group>
    <footer-btn title="提交" @submit="onSubmit()"></footer-btn>
  </article>
</template>
<script>
import { Group, XTextarea } from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'

export default {
  components: {
    Group,
    XTextarea,
    FooterBtn
  },
  data() {
    return {
      isClicked: false, // 防止重复点击
      queryForm: {
        action: '', // 通过或驳回
        note: ''
      }
    }
  },
  created() {
    let params = this.$route.params
    this.queryForm.action = params.action
  },
  methods: {
    onSubmit() {
      if (this.isClicked) return false
      if (this.queryForm.note) {
        this.isClicked = true // 防止多次请求
        let params = this.$route.params
        this.$rest.outBound.reviewOutbound(this.queryForm, `${params.id}/review/${params.role}`).then(res => {
          if (res.code === 0) {
            let sucUrl = {
              approve: `/outbound/succ/${params.id}`,
              reject: `/outbound/succ/${params.id}?needConfig=error`
            }
            this.$router.push(sucUrl[params.action])
          } else {
            this.showToast(res.message)
          }
          this.isClicked = false
        })
      } else {
        this.showToast('请输入备注内容')
      }
    }
  }
}

</script>
<style scoped lang="less">
@import '../../stylesheets/base/fn';
.operate_from {
  margin-bottom: 120/@w2;
  .tips-title {
    padding-top: 40/@w2;
    font-size: 30/@w2;
    text-indent: 30/@w2;
    line-height: 1;
  }

  .tips-finish {
    padding-top: 15/@w2;
    font-size: 26/@w2;
    color: #A9A9A9;
  }

  .tips-reject {
    color: #fb3f3f;
  }

}

</style>
